import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Decryptedid } from "../../Util/BcruptEncyptid";
import LoaderComponent from "./LoaderComponent";
import {
  getAuthenticatedHomeRoute,
  getAuthToken,
  hasAuthenticatedUserData,
  isAllowedAuthenticatedRoute,
} from "../../Util/authRedirect";

const PrivateAuthRoutes = () => {
  const location = useLocation();
  const rehydrated = useSelector((state) => state?.authSlice?._persist?.rehydrated);
  const userData = useSelector((state) => state?.authSlice.userData?.payload);
  const authToken = getAuthToken(userData);

  if (location.pathname.includes("/shared-collection/student/")) {
    const id = location.pathname.split("/shared-collection/student/")[1];
    let idval = id;
    try {
      idval = Decryptedid(atob(id));
      if (!idval || idval.trim() === "") idval = id;
    } catch (error) {
      idval = id;
    }
    window.location.replace(
      `https://peerscroller.onelink.me/gTJq/fydlv6xg?collectionId=${id}&af_force_deeplink=true`
    );
    return null;
  }

  if (location.pathname.includes("/video-shorts/")) {
    const decodedSearch = location.search.replace(/&amp;/g, "&");
    const urlParams = new URLSearchParams(decodedSearch);
    const role = urlParams.get("role");
    const isShareable = urlParams.get("isShareable");

    if (isShareable === "true" && role === "student") {
      const pathSegments = location.pathname.split("/");
      const videoId = pathSegments[pathSegments.length - 1];
      window.location.replace(
        `https://peerscroller.onelink.me/gTJq/fydlv6xg?videoId=${videoId}&af_force_deeplink=true`
      );
      return null;
    }
  }

  if (!rehydrated) return <LoaderComponent />;

  if (!authToken) {
    return (
      <Navigate
        to="/"
        state={location.pathname === "/settings" ? {} : { from: location }}
        replace
      />
    );
  }

  if (!hasAuthenticatedUserData(userData)) return <LoaderComponent />;

  return isAllowedAuthenticatedRoute(location.pathname, userData) ? (
    <Outlet />
  ) : (
    <Navigate to={getAuthenticatedHomeRoute(userData)} replace />
  );
};

export default PrivateAuthRoutes;
